const {
  VITE_API_URL,
  VITE_LANG,
  VITE_BASE_URL,
  VITE_CLIENT_ID,
  VITE_ISSUER,
  VITE_REDIRECT_URI,
  VITE_POST_LOGOUT_REDIRECT_URI,
  DEV,
  VITE_BASE_SUN_PORTAL_URL,
  VITE_LOGIN_SUN_PORTAL,
  VITE_DOMAIN_NAME,
  VITE_ENV_ACTIVE,
  VITE_EKYC_OCR_LIMIT,
  VITE_EKYC_LIVENESS_LIMIT,
  VITE_ENABLE_EKYC_E_RECRUITMENT,
  VITE_ENABLE_EKYC_CHECK_IN,
  VITE_S3_LINK,
} = import.meta.env;

export const API_HOST_NAME = VITE_API_URL;
export const DOMAIN_NAME = VITE_DOMAIN_NAME;
export const API_CUSTOM_APPLICATION_FORM_PATH = '/';
export const API_CUSTOM_PATH = '/';
export const API_CONTEXT_PATH = '/sales-portal';
export const API_DOCUMENTS_PATH = `${API_CONTEXT_PATH}/documents`;
export const API_POLICY_PATH = `${API_CONTEXT_PATH}/policies`;
export const API_ERECRUITMENT_PATH = `${VITE_API_URL}/e-recruitment`;
export const API_FTA_ERECRUITMENT_PATH = `${VITE_API_URL}/fta-e-recruitment`;
export const API_ERECRUITMENT_PUB_PATH = `${VITE_API_URL}/pub/e-recruitment`;
export const API_ERECRUITMENT_PATH_V2 = `${VITE_API_URL}/v2/e-recruitment`;
export const API_ERECRUITMENT_PATH_V2_PUB = `${VITE_API_URL}/pub/v2/e-recruitment`;
export const API_CHECK_IN = `${VITE_API_URL}/check-in`;

export const API_EPROMOTION_PATH = `${VITE_API_URL}/e-submission`;

export const API_FEE_PATH = `/receipt`;
export const API_SP_POLICY_PATH = `/policy`;
export const API_TEAM_POLICY_PATH = '/team/policy';
export const API_CONTRACT_UPLOAD_PATH = `${VITE_API_URL}/upload`;
export const API_CLIENT_CUSTOM_PATH = '/';
export const API_CUSTOM_SAVANT_EKYC_PATH = '/';
export const API_CUSTOM_SAVANT_PATH = '/';
export const API_FCRM_SEARCH_PATH = '/';
export const API_COMMON_DATA_LOV_PATH = '/';
export const API_CUSTOM_CLIENT_PATH = '/';
export const API_PAYMENT_SEARCH_PATH = '/';
export const API_QUESTION_SEARCH_PATH = '/';
export const API_WARD_SEARCH_PATH = '/';
export const API_REFRESH_TOKEN_PATH = '/';
export const API_APPLICATION_MASTER_PATH = '/';
export const API_RECRUITMENT_PROGRESS_REPORT_PATH =
  '/recruitment-progress-report';

export const API_E_CARD_PATH = '/agent/e-card';
export const API_AGENT_REQUEST_PATH = '/agent/agent-request';
export const API_PAYSLIP_PATH = '/payslip';
export const API_SALES_PORTAL_PATH = '/sales-portal';
export const API_SALES_PORTAL_PERSISTENCE_PATH =
  API_SALES_PORTAL_PATH + '/persistence';
export const API_SALES_PORTAL_SALE_REPORT_PATH =
  API_SALES_PORTAL_PATH + '/sale-report';
export const API_E_RECOGNITION_PATH = '/e-recognition';
export const API_AGENT_PATH = '/agent';
export const API_TRAJET_REPORT_PATH = '/trajet-report';
export const API_E_REQUEST_BASE_PATH = '/e-request';

export const LANG = VITE_LANG || 'vi';
export const BASE_URL = VITE_BASE_URL;
export const CLIENT_ID = VITE_CLIENT_ID;
export const ISSUER = VITE_ISSUER;
export const REDIRECT_URI = VITE_REDIRECT_URI;
export const POST_LOGOUT_REDIRECT_URI = VITE_POST_LOGOUT_REDIRECT_URI;
export const LOGIN_SUN_PORTAL = VITE_LOGIN_SUN_PORTAL;
export const BASE_SUN_PORTAL_URL = VITE_BASE_SUN_PORTAL_URL;

export const isDev = DEV;

export const URL_CLIENT_SERVICES = '/policy/clientInquiry';
export const ENV_ACTIVE = VITE_ENV_ACTIVE;

export const EKYC_OCR_LIMIT = VITE_EKYC_OCR_LIMIT;
export const EKYC_LIVENESS_LIMIT = VITE_EKYC_LIVENESS_LIMIT;
export const EKYC_ENABLE_E_RECRUITMENT = VITE_ENABLE_EKYC_E_RECRUITMENT;

export const EKYC_ENABLE_EKYC_CHECK_IN = VITE_ENABLE_EKYC_CHECK_IN;

export const S3_LINK = VITE_S3_LINK;
export const API_E_PROMOTION_PATH = `${VITE_API_URL}/e-submission`;
export const API_E_PROMOTION_PUB_PATH = `${VITE_API_URL}/pub/e-submission`;
